module.exports = __webpack_public_path__ + "static/media/142.b7548db6.jpg";